/* Swopti animerad favicon. Kraver en sprite-PNG med rutorna staplade lodratt.
   <link rel="icon" id="swopti-favicon" href="/favicon-32.png">
   <script src="/swopti-favicon-spin.js"
           data-sprite="/favicon-sprite-flip.png"
           data-frames="40" data-size="64" data-fps="20" data-mode="once"></script>
   data-mode: "once" (ett varv vid sidladdning), "focus" (ett varv nar fliken
   aktiveras igen), "loop" (oavbrutet). */
(function () {
  var el = document.currentScript, d = (el && el.dataset) || {};
  var cfg = {
    sprite: d.sprite || '/favicon-sprite-flip.png',
    frames: parseInt(d.frames || '40', 10),
    size: parseInt(d.size || '64', 10),
    fps: parseInt(d.fps || '20', 10),
    mode: d.mode || 'once'
  };
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var link = document.querySelector('link[rel~="icon"]');
  if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
  var rest = link.getAttribute('href');

  var cv = document.createElement('canvas');
  cv.width = cv.height = cfg.size;
  var ctx = cv.getContext('2d');
  var img = new Image();
  var timer = null, frame = 0;

  function paint(i) {
    ctx.clearRect(0, 0, cfg.size, cfg.size);
    ctx.drawImage(img, 0, i * cfg.size, cfg.size, cfg.size, 0, 0, cfg.size, cfg.size);
    try { link.href = cv.toDataURL('image/png'); } catch (e) { stop(true); }
  }
  function stop(hard) {
    clearInterval(timer); timer = null; frame = 0;
    if (hard && rest) link.href = rest; else paint(0);
  }
  function run(loop) {
    if (timer) return;
    frame = 0;
    timer = setInterval(function () {
      frame++;
      if (frame >= cfg.frames) { if (loop) { frame = 0; } else { stop(); return; } }
      paint(frame);
    }, Math.round(1000 / cfg.fps));
  }

  img.onload = function () {
    if (cfg.mode === 'loop') run(true);
    else if (cfg.mode === 'focus') {
      run(false);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) run(false);
      });
    } else run(false);
  };
  img.onerror = function () { /* sprite saknas: statisk favicon behalls */ };
  img.src = cfg.sprite;

  window.swoptiFavicon = { start: run, stop: stop, cfg: cfg };
})();
